export default __webpack_public_path__ + "static/media/e-wallet.df0f2f5d.png";